import AdminNavbar from "../../../components/layouts/AdminNavbar";
import { CenteredLayout } from "../../../components/layouts";

const ResourceAllocation = () => {
  return (
    <>
      <AdminNavbar />
      <CenteredLayout>{null}</CenteredLayout>
    </>
  );
};

export default ResourceAllocation;
